module.exports = __webpack_public_path__ + "static/media/lake.54e55bc7.jpg";